import { CartHeaders } from './Cart/CartHeaders';


export class CartVM{

    public header = new CartHeaders();

    public activeCart: any;

    public savedCarts: any;

    public static InitVM = new Promise((resolve) => {
        console.group("Init Cart VM...");
        console.time("InitCartVM")
        let self = new CartVM();
        window.cartVM = self;
        console.info("CartVM initialized");

        // Reset headers
        function emptyCart() {
            return new Promise<void>((resolve) => {
                console.info("Removing cart key");
                localStorage.removeItem('CartSessionKey');
                resolve()
            })

        }

        let emptyCartPaths = [
            "/ShoppingCart/SaveCart",
            "/ShoppingCart/RequestQuote",
            "/ShoppingCart/SubmitQuote",
            "/ShoppingCart/SubmitReview"
        ]



        if (emptyCartPaths.indexOf(window.location.pathname) != -1) {
            console.info("Resetting cart...");
            emptyCart().then(() => {
                console.info("Cart headers and summary reset");
            })
        }

        //setTimeout(() => { throw ("Test error handling in CartVM init promise"); }, 0);

        // Saved Carts //
        // TODO: James: split this method's endpoint into one to get the count and one to get the cart array

        if (window.UserMeta) {
            self.header.GetSavedCarts();
        }

        resolve(self);

        
    }).then((cartVM: CartVM) => {

        console.timeEnd('InitCartVM');
        console.groupEnd();

        let path = window.location.pathname;
        let cartUrl = "/ShoppingCart";

        console.time("GetCartHeader")
        cartVM.header.GetHeader()
            .then(() => {
                
                // Active Cart //
                // Redirect if we accidentally get here (mostly during development)
                if (path === cartUrl + "/Index" || path === cartUrl + "/") {
                    window.location.href = cartUrl;
                }

                if (path === cartUrl || path === cartUrl + "/Checkout") {

                    import('./Cart/ActiveCart' /* webpackChunkName: "shopping-cart" */).then((viewModel) => {
                        console.info("Initialize Active Cart...")
                        let model = window.Model;
                        let activeCart = new viewModel.ActiveCart(cartVM.header, model);

                        if (path !== cartUrl + "/Checkout") {
                            let vm = window.vm = activeCart;
                            ko.applyBindings(vm, document.getElementById('active-cart'));
                            console.info("Active Cart VM bound");
                            $(".siteloader").hide();
                        }
                        else {
                            import('./Cart/CheckOut' /* webpackChunkName: "checkout" */).then((viewModel) => {
                                console.info("Initializing CheckoutVM...");                                
                                let vm = window.vm = ko.validatedObservable(new viewModel.CheckOut(cartVM.header, model))();

                                ko.applyBindings(vm, document.getElementById('checkout-panel'));
                                console.info("CheckoutVM bound");

                            });
                        }
                    })
                }

                if (path !== cartUrl) {
                    $('#cart-icon-panel').mouseenter(function () {
                        // Pause slightly before showing the container
                        setTimeout(function () {
                            $('#cart-preview-container').show('slow');
                        }, 800);
                    });

                    $('#page-header').mouseleave(function () {
                        setTimeout(function () {
                            $('#cart-preview-container').hide('slow');
                        }, 800);

                    });
                }
            })
    })

    constructor() {

    }
}